import { WM_CONSUMER_ID } from 'services/utility/constants'

export default {
  getProfile: {
    url: '/api/v1/profile',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  signOut: {
    url: '/api/v1/logout?requestorigin=asda',
    method: 'GET',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  getOffers: {
    url: '/p13nservice/personalisation',
    method: 'POST',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
  addFavourites: {
    url: '/api/v2/favourites/update',
    method: 'POST',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
  removeFavourites: {
    url: '/api/v2/favourites/delete',
    method: 'POST',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
  viewFavouritesItemListV2: {
    url: '/api/v2/favouritesitems/viewlist',
    method: 'GET',
    api_version: 2,
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
    ignoreError: true,
  },
  serviceEligibility: {
    url: '/api/postcode/service-eligibility',
    method: 'GET',
    cache: 'default',
    dataType: 'json',
    ignoreError: true,
  },
}



// WEBPACK FOOTER //
// ./services/api/url-config.js